// import Swiper from '/node_modules/swiper/swiper-bundle.js';
import Swiper from '../lib/swiper/swiper-bundle.js';

window.addEventListener('load', function () {
	const swiper = new Swiper('.about-certificate__slider-container.swiper-container', {

		// Optional parameters
		direction: 'horizontal',
		loop: true,
		slidesPerView: 5,
		slidesPerGroup: 5,
		spaceBetween: 30,
		speed: 700,

		// If we need pagination
		pagination: {
			el: '.swiper-pagination.about-certificate__pagination',
			clickable: true
		},

		// Navigation arrows
		navigation: {
			nextEl: '.swiper-button-next.about-certificate__next',
			prevEl: '.swiper-button-prev.about-certificate__prev',
		},
		breakpoints: {
			320: {
				slidesPerView: 1.6,
				slidesPerGroup: 1,
			},
			560: {
				slidesPerView: 3,
				slidesPerGroup: 3,
			},
			991: {
				slidesPerView: 5,

			}
		}
	});

	const swiperStore = new Swiper('.about-stores__slider.swiper-container', {
		// Optional parameters
		direction: 'horizontal',
		loop: true,
		slidesPerView: 5,
		speed: 700,
		spaceBetween: 30,

		// If we need pagination
		pagination: {
			el: '.swiper-pagination.about-stores__pagination',
			clickable: true
		},

		// Navigation arrows
		navigation: {
			nextEl: '.swiper-button-next.about-stores__next',
			prevEl: '.swiper-button-prev.about-stores__prev',
		},

		breakpoints: {
			320: {
				slidesPerView: 1.5,

			},
			560: {
				slidesPerView: 2,
			},
			991: {
				slidesPerView: 5,
			}
		}
	});

});


const mediaQuery = window.matchMedia('(max-width: 991px)');
const mission = document.querySelector('.mission');
const missionLeft = document.querySelector('.mission__left');
const missionTitle = document.querySelector('.mission__title');
const missionRight = document.querySelector('.mission__right');
const missionRightImg = document.querySelector('.mission__right-img');
const aboutCharity = document.querySelector('.about-charity');
const aboutCharityTitle = document.querySelector('.about-charity__title');
const aboutCharityPic = document.querySelector('.about-charity__picture');

function mobileInit(e) {
	if (!mission) return false;
	if (e.matches) {
		missionTitle.after(missionRightImg);
		missionLeft.append(missionRight);
		aboutCharityTitle.append(aboutCharityPic);
	} else {
		mission.append(missionRight);
		missionRight.prepend(missionRightImg);
		aboutCharity.append(aboutCharityPic);
	}
};


mediaQuery.addListener(mobileInit);
mobileInit(mediaQuery);